import React from 'react';
import LoadBody from './LoadBody';

const Loads = () => <div className="h-100">
    <LoadBody />
</div>

export default Loads;